
import { createContext } from "react"

const paperTypeContext = createContext();

export default paperTypeContext;